import { Theme } from "./types";

export const lightTheme: Theme = {
  color: {
    "100": "#F0F4F8",
    "200": "#f7f7f7",
    "300": "#BCCCDC",
    "400": "#ddd",
    "500": "#829AB1",
    "600": "#627D98",
    "700": "#486581",
    "800": "#334E68",
    "900": "#243B53",
    cardTitle: "rgba(0, 0, 0, 0.5);",
    background: "white",
    textColor: "black",
  },
};
export const darkTheme: Theme = {
  color: {
    "900": "#CAF0F8",
    "800": "#ADE8F4",
    "700": "#90E0EF",
    "600": "#48CAE4",
    "500": "#00B4D8",
    "400": "#0096C7",
    "300": "#0077B6",
    "200": "#023E8A",
    "100": "#03045E",
    cardTitle: "white",
    background: "#03045E",
    textColor: "white",
  },
};
